import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Goodies.css';
import logo from '../assets/logo.svg';
import goodiesImage from '../assets/goodies.png';
import WebGLBackground from './WebGLBackground';
import { ROUTES } from '../constants/app';

function Goodies() {
  const navigate = useNavigate();
  const location = useLocation();
  const employeeData = location.state?.employeeData;
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer);
          navigate(ROUTES.HOME);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleOkay = () => {
    navigate(ROUTES.HOME);
  };


  return (
    <div className="goodies-page">
      <WebGLBackground 
        height="100vh" 
        width="100%" 
        left="0" 
        opacity={0.8}
      />
      <div className="goodies-content">
        <h1 className="goodies-title">Next, collect your goodies</h1>
        
        <div className="goodies-image-container">
          <img src={goodiesImage} alt="Goodies" className="goodies-image" />
        </div>

        <div className="redirect-message">
          <p className="countdown-text">
            Redirecting to Home Screen in {countdown} seconds
          </p>
        </div>

        <button className="okay-button" onClick={handleOkay}>
          Go Home Now
        </button>
      </div>

      <div className="goodies-logo">
        <img src={logo} alt="India Exchange 25 Chennai" className="event-logo" />
      </div>
    </div>
  );
}

export default Goodies;
